module.exports = __webpack_public_path__ + "static/media/sense4106.be86bb72.jpg";